module.exports = __webpack_public_path__ + "static/media/3.7ae7ae89.svg";